import styled from 'styled-components';
import { Container } from '../../styles/Common';

const Header = () => {
  return (
    <Container>
      <Wrapper>
        <Heading>
          <span>FULFILLMENT SOLUTIONS</span>
        </Heading>
      </Wrapper>
    </Container>
  );
};

export default Header;

const Wrapper = styled.div`
  padding: 85px 0;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (max-width: 576px) {
    padding: 30px 0;
  }
`;

const Heading = styled.h1`
  margin: 0 auto 20px auto;
  max-width: 25ch;
  font-weight: 700;
  font-family: font-bold;
  font-size: 55px;
  text-align: center;
  line-height: 1.4;
  background: linear-gradient(90deg, #5ca6ed 0%, #b475f8 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;

  @media (max-width: 576px) {
    font-size: 32px;
    margin-bottom: 12px;
  }
`;
